import React from "react";
import { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS, LIFECYCLE } from "react-joyride";
import { ExploreIcon } from "../../utils/icons";
import { TOUR_STEPS } from "./steps/MainScreenStepsLg";
import { TOUR_STEPS_MOB } from "./steps/MainScreenStepsMob";
import { getTourStateFromUserMetaData, updateTourStateInUserMetaData } from "../../firestoreQueries";
import { getUserEmail } from "../../utils/utils";
let width =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;
let initial_steps;
if (width >= 768) {
  initial_steps = TOUR_STEPS;
} else initial_steps = TOUR_STEPS_MOB;
let INITIAL_STATE = {
  key: new Date(), // This field makes the tour to re-render when we restart the tour
  run: false,
  continuous: true,
  loading: false,
  stepIndex: 0,
  steps: initial_steps,
  hamburgerClicked: false,
};

// Reducer will manage updating the local state
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "RUN_FALSE":
      return { ...state, run: false };
    case "WAIT_TO_LOAD_PAGE":
      return { ...state, run: action.run, stepIndex: action.stepIndex };
    case "SLATE_CARD_CLICK":
      setTimeout(() => {
        let btn = document.querySelector(
          "#react-joyride-step-3 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button:nth-child(3)"
        );
        if (btn !== null) {
          btn.click();
        }
      }, 100);
      return state;
    case "CENTRAL_MODAL_CLICK":
      setTimeout(() => {
        let btn = document.querySelector(
          "#react-joyride-step-0 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button"
        );
        if (btn !== null) {
          btn.click();
        }
      }, 400);
      return state;
    case "LINEUP_ICON_CLICK_LG":
      setTimeout(() => {
        let btn = document.querySelector(
          "#react-joyride-step-15 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button:nth-child(3)"
        );
        if (btn !== null) {
          btn.click();
        }
      }, 400);
      return state;
    case "LINEUP_GENERATION_LI_CLICK":
      setTimeout(() => {
        // Mobile View

        let btn = document.querySelector(
          "#react-joyride-step-16 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button"
        );
        if (btn === null) {
          // Large Screen View

          btn = document.querySelector(
            "#react-joyride-step-16 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button"
          );
        }
        if (btn !== null) {
          btn.click();
        }
      }, 400);
      return state;

    case "HAM_CLICK":
      // console.log("action ham_click");
      const { hamburgerClicked } = state;
      // I need to control here about back from previous or back to menu as well
      setTimeout(() => {
        let btn = document.querySelector(
          "#react-joyride-step-10 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button:nth-child(3)"
        );
        // console.log(btn);
        if (btn !== null) {
          btn.click();
        }
      }, 400);

      return { ...state, hamburgerClicked: !hamburgerClicked };
    case "LINEUPS_CLICKED":
      // Mobile View
      setTimeout(() => {
        let btn = document.querySelector(
          "#react-joyride-step-15 > div > div > div.react-joyride__tooltip > div:nth-child(2) > button:nth-child(3)"
        );
        if (btn !== null) {
          btn.click();
        }
      }, 400);
      return state;
    case "START":
      return { ...state, run: true };
    case "RESET":
      return { ...state, stepIndex: 0 };
    case "STOP":
      return { ...state, run: false };
    case "NEXT_OR_PREV":
      return { ...state, ...action.payload };
    case "RESTART":
      return {
        ...state,
        stepIndex: 0,
        run: true,
        loading: false,
        key: new Date(),
      };
    case "STEPS":
      return { ...state, action };
    default:
      return state;
  }
};

const Tour = () => {


  const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);
  useEffect(() => {
    // Auto start the tour if the tour is not viewed before
    const checkTourStatus = async () => {
      const email = await getUserEmail();
      const tourStateFromUserMetaData = await getTourStateFromUserMetaData(email)
      if (tourStateFromUserMetaData === null) {
        throw new Error("No such document!");
      } else {
        if (tourStateFromUserMetaData === true) {
          dispatch({ type: "START" });
        }
        else{
          dispatch({ type: "STOP" });
        }
      }
    };

    checkTourStatus();

    const handleCenterModalClick = (event) => {
      dispatch({ type: "CENTRAL_MODAL_CLICK" });
    };
    const handleLIconClicked = (event) => {
      dispatch({ type: "LINEUP_ICON_CLICK_LG" });
    };
    const handleHamburgerClick = (event) => {
      dispatch({ type: "HAM_CLICK" });
    };
    const handleLineupsClicked = (event) => {
      dispatch({ type: "LINEUPS_CLICKED" });
    };
    const handleLineupsGenerationLiClicked = (event) => {
      dispatch({ type: "LINEUP_GENERATION_LI_CLICK" });
    };

    // Central Modal Click
    let centralModalButton = document.querySelector(
      "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > button.btn.px-2.nav-item.active.align-items-center.align-self-center.central-button"
    );

    if (centralModalButton !== null) {
      centralModalButton.addEventListener("click", handleCenterModalClick);
    }

    let hm = document.getElementById("hamburger_btn");
    if (hm !== null) {
      hm.addEventListener("click", handleHamburgerClick);
    }
    let lli = document.getElementById("lineup-li");
    if (lli !== null) {
      lli.addEventListener("click", handleLineupsClicked);
    }
    let lineupGenli = document.querySelector(
      "#staticBackdropLineUp > div > div > div:nth-child(2) > ul > li"
    );

    let licon = document.querySelector(
      "#root > div > nav > div"
    );
    if (licon !== null) {
      licon.addEventListener("click", handleLIconClicked);
    }

    if (lineupGenli !== null) {
      lineupGenli.addEventListener("click", handleLineupsGenerationLiClicked);
    }
    if (!localStorage.getItem("tour")) {
      dispatch({ type: "START" });
    }
    return () => {
      // Central Modal Click

      let centralModalButton = document.querySelector(
        "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > button.btn.px-2.nav-item.active.align-items-center.align-self-center.central-button"
      );

      if (centralModalButton !== null) {
        centralModalButton.removeEventListener("click", handleCenterModalClick);
      }
      let hm = document.getElementById("hamburger_btn");
      if (hm !== null) {
        hm.removeEventListener("click", handleHamburgerClick);
      }
      let lli = document.getElementById("lineup-li");
      if (lli !== null) {
        lli.removeEventListener("click", handleLineupsClicked);
      }
      let lineupGenli = document.querySelector(
        "#staticBackdropLineUp > div > div > div:nth-child(2) > ul > li"
      );

      let licon = document.querySelector(
        "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > div > svg"
      );
      if (licon !== null) {
        licon.removeEventListener("click", handleLIconClicked);
      }
      if (lineupGenli !== null) {
        lineupGenli.removeEventListener(
          "click",
          handleLineupsGenerationLiClicked
        );
      }
    };
  }, [tourState.hamburgerClicked]);

  // Set once tour is viewed, skipped or closed
  const setTourViewed = async () => {
    await updateTourStateInUserMetaData(await getUserEmail(), false)
  };

  const handleSlateCardClick = (event) => {
    dispatch({ type: "SLATE_CARD_CLICK" });
  };
  const callback = (data) => {
    const { action, index, type, status, lifecycle } = data;

    if (
      // If close button clicked, then close the tour
      action === ACTIONS.CLOSE ||
      // If skipped or end tour, then close the tour
      (status === STATUS.SKIPPED && tourState.run) ||
      status === STATUS.FINISHED
    ) {
      setTourViewed();
      dispatch({ type: "STOP" });
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      // Check whether next or back button click and update the step.
      dispatch({
        type: "NEXT_OR_PREV",
        payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
      });
    } else if (index === 4 && lifecycle === LIFECYCLE.TOOLTIP) {
      if (tourState.hamburgerClicked) {
        setTimeout(() => {
          dispatch({
            type: "NEXT_OR_PREV",
            payload: { stepIndex: index + 1 },
          });
        }, 400);
      }
    } else if (index === 2) {
      let slateCard = document.querySelector(
        "#modal-content > div:nth-child(2) > div.container-fluid.bg-black > div > div"
      );
      if (slateCard !== null) {
        slateCard.addEventListener("click", handleSlateCardClick);
      }
    } else if (index === 4) {
      let slateCard = document.querySelector(
        "#modal-content > div:nth-child(2) > div.container-fluid.bg-black > div > div"
      );
      if (slateCard !== null) {
        slateCard.removeEventListener("click", handleSlateCardClick);
      }
    }
  };

  const startTour = () => {
    // Start the tour manually
    dispatch({ type: "RESTART" });
  };

  return (
    <>
      <div onClick={startTour}>
        <ExploreIcon className="text-primary"></ExploreIcon>
        <span className="align-items-center align-self-center ml-3">
          Walkthrough
        </span>
      </div>

      <JoyRide
        {...tourState}
        callback={callback}
        showSkipButton={true}
        showProgress={true}
        styles={{
          tooltipContainer: {
            textAlign: "left",
          },
          buttonBack: {
            marginRight: 10,
          },
        }}
        locale={{
          last: "End tour",
        }}
      />
    </>
  );
};

export default Tour;
